import cn from 'classnames';
import React__default, { useState, useRef, useEffect } from 'react';
import { useIsMobile, useTheme, useBoolean } from '@sravni/react-utils';
import modules_3999ddfa from './Iframe.module.scss.js';

const sendMessageToSpecialOffersFrontend = (iframeRef, payload) => {
    iframeRef?.current?.contentWindow?.postMessage({
        source: 'special-offers-iframe-wrapper',
        payload,
    }, '*');
};
const Iframe = ({ iframeSrc, domain, pushEvent, iframeId: propsIframeId, onLoad, setItemsCount, activeTabType, maxDesktopVisibleItems, handleReceivingAvailableTabs, tabs, isWithLinkToAll = true, }) => {
    const [iframeHeight, setIframeHeight] = useState(0);
    const isMobile = useIsMobile();
    const [theme] = useTheme();
    const [isLoaded, setLoaded] = useBoolean(false);
    const iframeRef = useRef(null);
    const handleLoad = () => {
        setLoaded.on();
        onLoad && onLoad();
    };
    useEffect(() => {
        const listener = ({ origin, data }) => {
            const { source, payload } = data;
            if (origin !== domain || source !== 'special-offers')
                return;
            const { height, url, type, event, iframeId, itemsCount, availableTabs } = payload;
            if (iframeId !== propsIframeId)
                return;
            if (type === 'itemsCount') {
                setItemsCount(itemsCount);
                return;
            }
            if (type === 'generalLinkClick') {
                window.top ? (window.top.location.href = url) : (window.location.href = url);
                return;
            }
            if (type === 'changeHeight') {
                setIframeHeight(height);
                return;
            }
            if (type === 'pushEvent') {
                pushEvent(event);
                return;
            }
            if (type === 'listenerIsAdded') {
                handleLoad();
                return;
            }
            if (type === 'availableTabs') {
                handleReceivingAvailableTabs(availableTabs);
                return;
            }
        };
        window.addEventListener('message', listener);
        return () => {
            window.removeEventListener('message', listener);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [domain, handleReceivingAvailableTabs, propsIframeId, pushEvent, setItemsCount, setLoaded]);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeTheme',
            theme,
        });
    }, [isLoaded, theme]);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'changeIsMobile',
            isMobile,
        });
    }, [isLoaded, isMobile]);
    useEffect(() => {
        if (!isLoaded || !activeTabType)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'activeTabType',
            activeTabType,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTabType?.subtype, activeTabType?.type, isLoaded]);
    const tabsDeps = JSON.stringify(tabs);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'allTabs',
            allTabs: tabs,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoaded, tabsDeps]);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'maxDesktopVisibleItems',
            maxDesktopVisibleItems,
        });
    }, [maxDesktopVisibleItems, isLoaded]);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'pageUrl',
            pageUrl: document.location.href,
        });
    }, [isLoaded]);
    useEffect(() => {
        if (!isLoaded)
            return;
        sendMessageToSpecialOffersFrontend(iframeRef, {
            type: 'isWithLinkToAll',
            isWithLinkToAll,
        });
    }, [isLoaded, isWithLinkToAll]);
    return (React__default.createElement("iframe", { height: `${iframeHeight}px`, style: { minHeight: `${iframeHeight}px`, maxHeight: `${iframeHeight}px` }, className: cn(modules_3999ddfa.iframe), src: iframeSrc, title: 'Интересные предложения', ref: iframeRef }));
};

export { Iframe };
//# sourceMappingURL=Iframe.js.map
